export const SHORTLIST_ADDED_EVENT = 'shortlist-added-notification';
export const SHORTLIST_REMOVED_EVENT = 'shortlist-removed-notification';

export function syncShortlistHeaderCount(count) {
  const shortlistCount = Number(count);
  if (!Number.isFinite(shortlistCount) || shortlistCount < 0) return;

  document.querySelectorAll('span[data-shortlist]').forEach((icon) => {
    icon.setAttribute('data-shortlist', shortlistCount);
    icon.classList.toggle('nineplus', shortlistCount > 9);
    icon.classList.add('change', 'animate-heart');

    setTimeout(() => {
      icon.classList.remove('change', 'animate-heart');
    }, 1000);
  });
}

function propertyAddress(property) {
  return (
    property.addressShort ||
    property.propertyName ||
    property.street ||
    property.name ||
    'Property'
  );
}

export function showShortlistAddedNotification(property = {}) {
  window.dispatchEvent(
    new CustomEvent(SHORTLIST_ADDED_EVENT, {
      detail: {
        address: propertyAddress(property),
      },
    })
  );
}

export function showShortlistRemovedNotification(property = {}, undo) {
  window.dispatchEvent(
    new CustomEvent(SHORTLIST_REMOVED_EVENT, {
      detail: {
        address: propertyAddress(property),
        undo,
      },
    })
  );
}
